import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export default function ICDiscord({}: ISvgIcon): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_336_19501)">
        <path
          d="M11.9998 0.444092C5.61885 0.444092 0.443848 5.62009 0.443848 12.0001C0.443848 18.3801 5.61985 23.5551 11.9998 23.5551C18.3808 23.5551 23.5558 18.3811 23.5558 12.0001C23.5558 5.61909 18.3798 0.444092 11.9998 0.444092ZM15.0158 16.3591C15.0158 16.3591 14.6028 15.8911 14.3078 15.4831C15.7358 15.0731 16.2698 14.2531 16.2698 14.2531C15.8018 14.5481 15.3738 14.7231 15.0268 14.8991C14.4938 15.1341 13.9598 15.2491 13.4268 15.3671C10.8998 15.7771 9.48185 15.0911 8.14085 14.5471L7.68285 14.3151C7.68285 14.3151 8.21685 15.1351 9.58785 15.5451C9.22785 15.9551 8.87085 16.4221 8.87085 16.4221C6.43085 16.3641 5.54085 14.8401 5.54085 14.8401C5.54085 11.4451 7.14585 8.69009 7.14585 8.69009C8.75185 7.52209 10.2398 7.57809 10.2398 7.57809L10.3598 7.69609C8.39485 8.16609 7.50385 9.04309 7.50385 9.04309C7.50385 9.04309 7.74285 8.92609 8.15885 8.74809C10.8048 7.70809 13.6948 7.78309 16.3698 9.10109C16.3698 9.10109 15.4778 8.28009 13.6338 7.75409L13.7968 7.59409C14.0518 7.59409 15.4008 7.64209 16.8438 8.69809C16.8438 8.69809 18.4588 11.4571 18.4588 14.8481C18.4058 14.7821 17.4568 16.3061 15.0158 16.3591Z"
          fill="#8E8E92"
        />
        <path
          d="M13.988 13.7881C14.611 13.7881 15.118 13.2621 15.118 12.6141C15.118 11.9701 14.614 11.4441 13.988 11.4441V11.4471C13.368 11.4471 12.86 11.9711 12.858 12.6201C12.858 13.2631 13.366 13.7881 13.988 13.7881ZM9.94299 13.7881C10.566 13.7881 11.073 13.2621 11.073 12.6141C11.073 11.9701 10.569 11.4441 9.94699 11.4441L9.94299 11.4471C9.31999 11.4471 8.81299 11.9711 8.81299 12.6201C8.81299 13.2631 9.31999 13.7881 9.94299 13.7881Z"
          fill="#8E8E92"
        />
      </g>
      <defs>
        <clipPath id="clip0_336_19501">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
